import { Injectable } from '@angular/core';
import {StudentAuthService} from "./student-auth.service";
import {DataService} from "./data.service";
import {take} from "rxjs";
import {TrophyItemType} from "../enums/trophy-item-type";

@Injectable({
  providedIn: 'root'
})
export class TrophyEndpointService {
  constructor(
    private studentAuthService: StudentAuthService,
    private dataService: DataService
  ) { }

  setTrophy(itemId: string, itemType: TrophyItemType) {
    if(this.studentAuthService.isLoggedIn()) {
      this.dataService.setTrophyCount({
        clientId: localStorage.getItem('clientId') ?? "",
        classCode: localStorage.getItem('schoolClassCode') ?? "",
        itemId: itemId,
        itemType: itemType
      }).pipe(take(1)).subscribe(response => {
        if(response) {
          console.log('Trophy set');
          console.log(response)
        }
      });
    }
  }

}
